module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hans/2/5-72dd38035fba0d916c288c93843d72b4.jpg";